import { PageViewEventLogger } from '@repo/tracking-service';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';
import { useQueryLoader } from 'react-relay';

import { employmentSpecialRelationshipsPastToCurrentlyQuery } from '@/__generated__/employmentSpecialRelationshipsPastToCurrentlyQuery.graphql';
import Spinner from '@/components/common/Spinner';
import { SurveyLayout } from '@/components/survey/common/SurveyProvider';
import { useSurveyUserEventAttributes } from '@/components/survey/common/hooks/use-survey-user-event-attributes';
import { PastToCurrentlySpecialRelationshipsContainer } from '@/components/survey/employment/special-relationships/PastToCurrentlySpecialRelationshipsContainer';
import { specialRelationshipsPastToCurrentlyQuery } from '@/graphql/query/survey/employment';
import { refundHistoryIdAtom } from '@/lib/stores/survey/common';

function PastToCurrentlySpecialRelationshipsPage() {
  const [queryRef, loadQuery] = useQueryLoader<employmentSpecialRelationshipsPastToCurrentlyQuery>(specialRelationshipsPastToCurrentlyQuery);
  const refundHistoryId = useAtomValue(refundHistoryIdAtom);
  const eventAttributes = useSurveyUserEventAttributes();

  useEffect(() => {
    if (refundHistoryId) {
      loadQuery({ refundHistoryId }, { fetchPolicy: 'network-only' });
    }
  }, [refundHistoryId, loadQuery]);

  if (!queryRef) return <Spinner />;
  return (
    <PageViewEventLogger pageName={'survey_special-relationships-past'} eventProperty={eventAttributes}>
      <PastToCurrentlySpecialRelationshipsContainer queryRef={queryRef} />
    </PageViewEventLogger>
  );
}

PastToCurrentlySpecialRelationshipsPage.getLayout = SurveyLayout;

export default PastToCurrentlySpecialRelationshipsPage;
